import { render, staticRenderFns } from "./CloseAmortizationModal.vue?vue&type=template&id=64ce2306&"
import script from "./CloseAmortizationModal.vue?vue&type=script&lang=ts&"
export * from "./CloseAmortizationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ce2306')) {
      api.createRecord('64ce2306', component.options)
    } else {
      api.reload('64ce2306', component.options)
    }
    module.hot.accept("./CloseAmortizationModal.vue?vue&type=template&id=64ce2306&", function () {
      api.rerender('64ce2306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Amortization/CloseAmortizationModal.vue"
export default component.exports